/* global YT */

import { allYouTubePlayers, toggleAllPlayers } from './video-controller';

const SELECTOR = '[data-youtube-id]';
const REDUCE_MOTION_BUTTON_SELECTOR = '.btn--pause';

export function init() {
    const elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    window.onYouTubeIframeAPIReady = () => {
        elements.forEach(node => {
            const videoId = node.getAttribute('data-youtube-id');
            let initialPlay = true;

            const player = new YT.Player(node.id, {
                videoId,
                playerVars: {
                    controls: node.getAttribute('data-show-controls') || 1,
                    autoplay: 1,
                    mute: 1,
                    disablekb: node.getAttribute('data-disable-keyboard') || 0,
                    enablejsapi: 1,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    showinfo: 0,
                    rel: 0,
                    height: node.getAttribute('data-width') || '1200',
                    width: node.getAttribute('data-height') || '675'
                },
                events: {
                    onReady: () => {
                        allYouTubePlayers.push(player);
                        player.playVideo();
                    },
                    onStateChange: event => {
                        if (event.data === YT.PlayerState.PLAYING && initialPlay) {
                            player.seekTo(0);
                            document.getElementById(node.id).classList.add('header-video--loaded');
                            initialPlay = false;
                        }

                        if (event.data === YT.PlayerState.ENDED) {
                            player.seekTo(0);
                            player.playVideo();
                        }
                    }
                }
            });
        });

        const buttons = document.querySelectorAll(REDUCE_MOTION_BUTTON_SELECTOR);
        buttons.forEach(button => {
            button.addEventListener('click', toggleAllPlayers);
        });
    };

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
}
